import "core-js/modules/es.regexp.exec.js";
import Drip from '@/drip';
import Url from 'drip/utils/url';

/**
 * 判定是否在美团且来自搜索 判定是否在安卓且来自美大猫且来自show-detail综合链接
 */
export function isLLCloseWebview() {
  var _Drip$constant$uaInfo = Drip.constant.uaInfo,
    IS_MEITUAN = _Drip$constant$uaInfo.IS_MEITUAN,
    IS_MAOYAN = _Drip$constant$uaInfo.IS_MAOYAN,
    IS_DIANPING = _Drip$constant$uaInfo.IS_DIANPING,
    osName = _Drip$constant$uaInfo.osName;
  var fromTag = Url.getQuery('fromTag') || '';
  var mtSearch = IS_MEITUAN && osName === 'android' && fromTag === 'search';
  var MDMShowDetail = (IS_MEITUAN || IS_MAOYAN || IS_DIANPING) && osName === 'android' && /movieshowlist\/show-detail/.test(document.referrer);
  if (mtSearch || MDMShowDetail) {
    return true;
  } else return false;
}